import { Injectable } from '@angular/core';
import { AppService } from '..//@core/service/App.Service';
import { ICompanyUserInput } from '@common/models/company-user.model'

@Injectable({ providedIn: 'root' })
export class CompanyUserService extends AppService<any> {
    constructor() {
        super('CompanyUser');
    }

    async getUserCompanies() {
        return await this.get('/userCompanies');
    }

    async getCompanyUserById(Id: number) {
        return await this.get(`/${Id}`);
    }

    async addCompanyUser(companyUser: ICompanyUserInput) {
        return await this.post('', companyUser);
    }

    async updateCompanyUser(companyUser: ICompanyUserInput, httpParams: any) {
        return await this.put('/updateCompanyUser', companyUser, httpParams);
    }

    async deleteCompanyUser(httpParams: any) {
        return await this.del('', httpParams);
    }
}
